import React, { useState } from 'react'
import { Card, CardContent, Button } from '@mui/material'
import Uploader from '../../features/valueLists/Uploader'

export const UploaderComponent = (props: any) => {
  const { handleImportData } = props
  const [dataSet, setDataSet] = useState<any>()
  const [showUpload, setShowUpload] = useState<any>(true)
  const [showImport, setShowImport] = useState<any>(false)

  const handleUploadData = (upload: any) => {
    let data = upload.data.filter((d: any) => {
      if (d[0] !== '') return d
    })
    setDataSet(data)
    setShowUpload(false)
  }

  const doUpload = () => {
    handleImportData(dataSet)
    setDataSet([])
    setShowImport(true)
  }

  return <>
    {(dataSet)
      ? <Card sx={{ marginBottom: 2 }}>
        <CardContent>
          Number of records to import: {dataSet.length}<br />
          <Button variant='contained' color='secondary' disabled={showImport} onClick={doUpload}>Import Data</Button>
        </CardContent>
      </Card>
      : null}
    {showUpload ? <Uploader handleUpload={handleUploadData} /> : null}
  </>
}